// Shape the Go services return for /healthz, /readyz, /livez.
// Mirrors internal/health/handler.go in notification_center and pii_access_control.
export type HealthStatus = {
  status: 'ok' | 'degraded' | 'down'
  service: string
  version: string
  time: string
  checks?: Record<string, { status: 'ok' | 'fail' | 'skipped'; error?: string }>
}

// BFF response wraps the upstream body with the HTTP status that came back —
// the SPA renders a pill from `httpStatus` because a 503 with a parseable body
// is still useful to display.
export type BffHealthResponse = {
  httpStatus: number
  body: HealthStatus | { error: string }
  fetchedAt: string
}

export async function fetchServiceHealth(slug: string): Promise<BffHealthResponse> {
  const res = await fetch(`/api/portal/services/${slug}/health`, {
    headers: { accept: 'application/json' },
  })
  if (!res.ok && res.status !== 503) {
    throw new Error(`portal BFF returned ${res.status}`)
  }
  return res.json()
}
